module.exports = __webpack_public_path__ + "static/media/cloud-music.7a0bf159.svg";